<template>
    <admin-layout>
        <template #header>
            Admin Dashboard
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto">
                <div class="bg-white overflow-hidden sm:rounded-lg">

                </div>
            </div>
        </div>
    </admin-layout>
</template>

<script>
import AdminLayout from '@/Layouts/AdminLayout'

export default {
    components: {
        AdminLayout
    },

    props: {
        suggestions: Array,
        recent: Array
    }
}
</script>
